import { openSplitViewState } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import { isOcrEnabledForTemplate } from 'shared/helpers';

export const useIsOcrUploadButtonVisible = (company: domain.Company, request: domain.Request) => {
    const openSplitView = useAtomValue(openSplitViewState);

    return (
        isOcrEnabledForTemplate(company, request.integrationCode) &&
        !openSplitView &&
        request.statusV2 === domain.RequestStatusV2.Draft
    );
};
